export default __webpack_public_path__ + "static/media/wallet_icon.1d8050c0.svg";